import React from 'react';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Content from './content';
import Header from './header';
import BottomFooter from './footer';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { search, footer, columnData, newsstream, columnId, isEnd, nav } = content;
        // const { logo } = columnData;

        const headerData = {
            search,
            columnData,
            nav,
        };

        const contentData = {
            newsstream,
            columnId,
            isEnd,
        };

        const footerData = {
            footer,
        };

        console.log(content);

        return (
            <div>
                <Header content={headerData} />
                <Content content={contentData} />
                <BottomFooter content={footerData} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default Layout;
